import { gql } from '@apollo/client'
import { PlanetMiddleLiteFragment } from '@src/graphql/fragment/planet'

export default gql`
  query GetMySeedPlanetsMiddleLite {
    getMySeedPlanet {
      planets {
        ...PlanetMiddleLite
      }
    }
  }

  ${PlanetMiddleLiteFragment}
`
